import { useMiniSite } from "../../components/minisite/context";
import { AboutGallery, BusinessLocationSection } from "../RentalProfile";

export default function MiniSiteAbout() {
  const { data, theme } = useMiniSite();
  const ms = data.mini_site || {};

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="ms-about-page">
      <h1 className="font-display text-3xl sm:text-4xl font-bold" style={{ color: theme }}>
        About {data.name}
      </h1>

      <div className="mt-5 max-w-3xl space-y-5 text-slate-700">
        {ms.about ? (
          <p className="whitespace-pre-line leading-relaxed">{ms.about}</p>
        ) : (
          <p className="text-slate-500 italic">The business hasn&apos;t added an about description yet.</p>
        )}

        {ms.why_choose_us && (
          <div className="rounded-xl border border-slate-200 bg-slate-50 p-4" data-testid="ms-about-why">
            <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">Why choose us</div>
            <p className="mt-1 whitespace-pre-line">{ms.why_choose_us}</p>
          </div>
        )}

        <div className="grid sm:grid-cols-2 gap-3">
          {ms.service_area_text && (
            <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="ms-about-service-area">
              <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">Service area</div>
              <p className="text-sm mt-1">{ms.service_area_text}</p>
            </div>
          )}
          {ms.pickup_delivery_notes && (
            <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="ms-about-pickup">
              <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">Pickup & delivery</div>
              <p className="text-sm mt-1">{ms.pickup_delivery_notes}</p>
            </div>
          )}
        </div>
      </div>

      {(data.about_images || []).length > 0 && (
        <div className="mt-6">
          <AboutGallery companyId={data.id} images={data.about_images} />
        </div>
      )}

      {data.business_location && (data.business_location.has_coordinates || data.business_location.city || data.business_location.label) && (
        <BusinessLocationSection location={data.business_location} />
      )}
    </div>
  );
}
